import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import css from './css/BackTextButton.module.css'
import {useNavigate} from "react-router-dom";


export default function BackTextButton({text, ...props})
{
    const navigate = useNavigate()

    return (
        <div className={`${css.wrapper} d-flex align-items-center ${props.className ? props.className : ''}`}>
            <FontAwesomeIcon className={css.backIcon} icon={faArrowLeft}/>
            <span className={`${css.text} ms-2`} onClick={() => { navigate(-1) }}>{text}</span>
        </div>
    )
}